
import Vue from 'vue';
import ImportFileForm from '@/components/ImportFile/Form.vue';

export default Vue.extend({
  name: 'ImportFiles',
  components: { ImportFileForm },
});
